<ras-page>
	<main>
		<h1>Report Your Experience</h1>

		<p class="lead">Please tell us why you're dissatisfied using the report form below. Thank you for taking the time to follow this procedure - it will ensure that your communication is promptly addressed</p>

		<form [ngClass]="{'show-invalid': show_invalid}" id="vip-form">
			<p>
				<label>First Name</label>
				<input [(ngModel)]="name" name="name" type="text" pattern="^.*[a-zA-Z].*$" required>
			</p>
			<p>
				<label>Surname</label>
				<input [(ngModel)]="surname" name="surname" type="text" pattern="^.*[a-zA-Z].*$" required>
			</p>
			<p>
				<label class="required">Cell</label>
				<input [(ngModel)]="cell" name="cell" type="text" [pattern]="valid.sa_cell_number_pattern" required [ngClass]="{invalid: !valid.sa_cell_number(cell)}">
				<span class="validation" *ngIf="show_invalid && !valid.sa_cell_number(cell)">Please provide a valid SA cell number</span>
			</p>
			<p>
				<label class="required">Email</label>
				<input [(ngModel)]="email" name="email" type="email" required [ngClass]="{invalid: !valid.email(email)}">
				<span class="validation" *ngIf="show_invalid && !valid.email(email)">Please provide an email address</span>
			</p>
			<p>
				<label class="required">Storage location</label>
				<select [(ngModel)]="location" name="location" [ngClass]="{invalid: !location}">
					<option value="" default *ngIf="!location"></option>
					<ng-container *ngFor="let location of locations">
						<option *ngIf="!location.disabled" [value]="location.name">{{location.display_name}}</option>
					</ng-container>
				</select>
				<span class="validation" *ngIf="show_invalid && !location">Please choose a location</span>
			</p>
			<p>
				<label class="required">Storage unit number</label>
				<input [(ngModel)]="unit" name="unit" type="text" pattern="^[0-9]+" required [ngClass]="{invalid: !valid.number(unit)}">
				<span class="validation" *ngIf="show_invalid && !valid.number(unit)">Please provide the unit number of your storage unit</span>
			</p>
			<p>
				<label>Message</label>
				<textarea [(ngModel)]="message" name="message"></textarea>
			</p>
			<p>
				<button type="button" (click)="send_message()">Submit</button>
			</p>
		</form>
	</main>
</ras-page>

<ras-spinner [active]="busy"></ras-spinner>

<ras-popup *ngIf="form_sent" (close)="form_sent = false">
	<p>Thank you for contacting us. A consultant will call you.</p>
</ras-popup>

<ras-popup *ngIf="form_error" (close)="form_error = false" [error]="true">
	<p>Thank you for contacting us. Unfortunately we seem to be experiencing technical difficulties at the moment. Please try again later, or call us on 0861{{'&nbsp;'}}73{{'&nbsp;'}}68{{'&nbsp;'}}27.</p>
</ras-popup>
